import { render, staticRenderFns } from "./PostBookingForm.vue?vue&type=template&id=5c6ed68e"
import script from "./PostBookingForm.vue?vue&type=script&lang=js"
export * from "./PostBookingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports